export default __webpack_public_path__ + "static/meshery-version-5dbe26bc558062b5cc58ff22a8e88b49.png";